import script from "./NewPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./NewPassword.vue?vue&type=script&setup=true&lang=js"

import "./NewPassword.vue?vue&type=style&index=0&id=30d69e25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30d69e25"]])

export default __exports__